import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//.test(path)) return path;
  return `${API}/files/${path}`;
};

export const isPdf = (path) => /\.pdf$/i.test(path || "");

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const fmtEur = (v) => (v == null ? "—" : v.toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }));
export const fmtPct = (v) => (v == null ? "—" : `${v.toLocaleString("it-IT", { maximumFractionDigits: 1 })}%`);

export const STATUS_LABELS = {
  concluso: "Operazione conclusa",
  in_sviluppo: "Operazione in sviluppo",
  in_valutazione: "In valutazione",
};

export const uploadFiles = async (files, { admin = false, folder = "projects" } = {}) => {
  if (admin) {
    const out = [];
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post(`/admin/upload?folder=${folder}`, fd);
      out.push(data.path);
    }
    return out;
  }
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  const { data } = await api.post("/uploads/public", fd);
  return data.map((d) => d.path);
};
